import { RouteHandler } from 'wee-routes';
import $ from 'wee-dom';
import $screen from 'wee-screen';

class Footer {
    constructor() {
        this.$footer = $(':footer');
    }

    wrapLinkBlockNumbers() {
        this.$footer.children().each((linkBlock) => {
            const linkBlockChildren = $('.js-footer-link', $(linkBlock));

            linkBlockChildren.each((child) => {
                const str = $(child).html();
                const reg = /\/\s(\d-\d{3}-\d{3}-\d{4})/;

                if (str.match(reg)) {
                    const newStr = str.replace(str.match(reg)[1],
                        `<span class="link-block__list-item-number">${str.match(reg)[1]}</span>`);

                    $(child).html(newStr);
                }
            });
        });
    }
}

export default new RouteHandler({
    init() {
        const footer = new Footer();
        footer.wrapLinkBlockNumbers();
    },
});
